// Copyright (c) StrangeBee 2023

import React, { ReactElement, useEffect, useState } from 'react';
import { Space } from 'antd';
import { SortDirections } from '@Hooks/useSort';
import { classList } from '@Helpers/className';

import './SortButton.scss';

const directions: Record<SortDirections, string> = {
    [SortDirections.NONE]: 'dir-none',
    [SortDirections.ASC]: 'dir-asc',
    [SortDirections.DESC]: 'dir-desc',
};

interface SortButtonProps {
    label: string;
    onSortChange?: (newDirection: SortDirections) => void;
    value?: SortDirections;
}

const SortButton = ({ label, onSortChange, value = SortDirections.NONE }: SortButtonProps): ReactElement => {
    const [sortDirection, setSortDirection] = useState<SortDirections>(value);

    useEffect(() => {
        setSortDirection(value);
    }, [value]);

    const handleClick = (): void => {
        const newDirection = sortDirection === -1 ? 0 : sortDirection === 0 ? 1 : -1;
        setSortDirection(newDirection);
        onSortChange?.(newDirection);
    };

    return (
        <div className="sort-button" onClick={handleClick}>
            <Space className={classList('sort-button__wrapper', directions[sortDirection])}>
                <span className="sort-button__label">{label}</span>
            </Space>
        </div>
    );
};

export default SortButton;
